import koi from "./koi.png";
import koi_prints from "./koi_prints.jpg";

let prints = [
  {
    id: 201,
    name: "Koi (Defective)",
    new_product: false,
    description: "5.5in x 6.75in cardstock print that got a little messed up :(",
    image: koi,
    images: [koi, koi_prints],
    price: {
      Small: "sold out",
      Medium: "unavailable",
      Large: "unavailable",
    },
  },
];

export default prints;
